export default {
    range: '<',
    thing: '<',
    filter: '<',
    eventsObservable: '<',
    greatestRangeLabel: '<',
    onChartSelection: '&',
    onMetadataChanged: '&',
    thresholds: '<?',
    alertEvents: '<?',
    onInitialized: '&',
    alertView: '<?' || false,
    showBigFormat: '<?' || false,
};
